<template>
  <div>
    <div class="wrapper">
      <div class="filterwrapper"> 
        <Forms 
          ref="form"
          v-if="selectedOption != null"
          @submit-form-data="submitForm"
          @goback="goback"
          :selectedOption="selectedOption" />
      </div>
    </div>
    <FilterNavigation 
      class="fixedtobottom"
      @setOption="setOption"
      :selectedOption="selectedOption"
      :options="options"/>
  </div>
</template>

<script>
import { computed } from "vue";
import FilterNavigation from "@/components/filterNavigation/filterNavigation.vue";
import Forms from '@/containers/desktop/Forms.vue';
import { useMenuStore } from "@/stores/menu.ts";
import { useEventSearch } from "@/stores/eventSearch.ts";
import { useHorarios } from "@/stores/horarios.ts";

 
export default {
  name: 'FiltersDetailView',
  props:["gobackfn"],
  emits:[
    "setOption","formsubmitted",
  ],
  components: {
    FilterNavigation,
    Forms
  },
  setup(){
    const menuStore = useMenuStore();
    const options = computed(() => menuStore.menuItems);
    const selectedOption = computed(() => menuStore.currentSelected);
    
    const eventsearch = useEventSearch();
    const selectedWeek = computed(()=> eventsearch.selectedWeek);
    function updateSearchFilter(filter) {
      eventsearch.updateSearchFilter(filter);
    }
    function updateCurrentFilters(updatedCurrentFilters){
      eventsearch.updateCurrentFilters(updatedCurrentFilters);
    }

    const horariosStore = useHorarios();
    function fetchHorarios(){
      horariosStore.fetchHorario();
    } 

    return {
      options,
      selectedOption,
      updateSearchFilter,
      updateCurrentFilters,
      selectedWeek,
      fetchHorarios
    }
  },
  mounted(){
    window.scrollTo(0,0);
  },
  methods: {
    callsearch(){
      this.$refs.form.submitForm();
    },
    submitForm(data){
      const [ selectedDates, params ] = data;
      this.$emit("formsubmitted");
      
      this.updateSearchFilter(this.selectedOption);
      this.updateCurrentFilters(
        {
          ciclo: params?.ciclo,
          ano: params?.ano,
          curso: params?.curso,
          cursoid: params?.curso?.valor,
          disciplina: params?.disciplina,
          turma: params?.turma,
          selectedWeek: selectedDates,
          sala: params?.sala,
          docente: params?.docente,
          avaliacao: params?.avaliacao,
          date: selectedDates,
          selectedOption:this.selectedOption
        }
      );
      this.fetchHorarios();
    },
    setOption(option) {
      this.$emit('setOption',option);
    },
    goback(){
      this.gobackfn();
    }
  }
}
</script>

<style scoped>
a{
  display: none;
}

/*.filterwrapper{
  position: relative;
}*/
.backnav{
    background-color: #292a2b;
    padding: 10px 15px;
    position: fixed;
    right: 0;
    left: 0;
    z-index: 5;
    top: 0;
    display: flex;
    justify-content: space-between;
  }

  .psqbtn{
    color: white;
    font-family: "Montserrat";
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .backnavbutton{
    padding-top: 5px;
    padding-bottom: 5px;;
  }

  .fixedtobottom{
    position: fixed;
  }

@media only screen and (max-width: 767px) {

  .filterwrapper{
    margin-top: 45px;
    margin-bottom: 55px;
  }

  .dateselector,.smallselector{
    display: none;
  } 

  a{
    display: flex;
    background-color: blue;
    color: white;
    padding: 10px;
    width: 300px;
    justify-content: center;
  }


  .wrapper {
    padding-left: 3%;
    padding-right: 3%;
  }

}    
</style>